import { ArrowRight, Clock, Target, Zap } from "lucide-react";

interface WelcomeStepProps {
  onNext: () => void;
}

const WelcomeStep = ({ onNext }: WelcomeStepProps) => {
  return (
    <div className="py-4">
      <h1 className="text-3xl font-extrabold text-gray-900 leading-tight mb-4">
        Willkommen bei Kandidat.io – Ihrer neuen Recruiting-Zentrale.
      </h1>

      <p className="text-gray-600 text-[15px] leading-relaxed mb-6">
        Vielen Dank, dass Sie Kandidat.io nutzen – der modernsten, schnellsten und effektivsten Recruiting-Zentrale
        speziell für die Pflege- und Gesundheitsbranche.
      </p>

      <p className="text-gray-500 text-sm leading-relaxed mb-8">
        Auf den nächsten Seiten führen wir Sie Schritt für Schritt durch alle wichtigen Punkte, die normalerweise in
        zeitintensiven Onboarding- oder Erstgesprächen besprochen werden.
      </p>

      <div
        className="border-l-4 border-l-primary rounded-r-lg px-6 py-5 mb-10"
        style={{ backgroundColor: "rgba(0, 153, 206, 0.05)" }}
      >
        <p className="font-bold text-gray-900 mb-2">Warum dieses Formular so wichtig ist</p>
        <p className="text-sm text-gray-600 leading-relaxed">
          Indem Sie sich einmal kurz Zeit nehmen, schaffen Sie die Basis für einen automatisierten Prozess, der Ihnen
          anschließend enorm viel Zeit im Recruiting spart. Ihre Angaben ermöglichen es uns, Ihre Recruiting-Kampagnen
          präzise aufzusetzen, optimale Bewerber anzusprechen und den gesamten Prozess so effizient wie möglich zu
          gestalten.
        </p>
      </div>

      <div className="grid grid-cols-3 gap-4 mb-10">
        <FeatureCard icon={<Clock className="w-5 h-5" />} title="Ca. 20 Minuten" description="Einmalig ausfüllen, dauerhaft profitieren." />
        <FeatureCard icon={<Target className="w-5 h-5" />} title="Präzise Kampagnen" description="Wir sprechen genau die richtigen Bewerber für Sie an." />
        <FeatureCard icon={<Zap className="w-5 h-5" />} title="Schneller starten" description="Nach dem Ausfüllen richten wir alles für Sie ein." />
      </div>

      <div className="flex justify-end">
        <button
          type="button"
          onClick={onNext}
          className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-white bg-primary rounded-lg hover:opacity-90 transition-colors"
        >
          Jetzt starten
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

const FeatureCard = ({
  icon,
  title,
  description,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
}) => {
  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-5">
      <div
        className="w-10 h-10 rounded-full flex items-center justify-center mb-3 text-primary"
        style={{ backgroundColor: "rgba(0, 153, 206, 0.1)" }}
      >
        {icon}
      </div>
      <p className="font-semibold text-gray-900 text-sm mb-1">{title}</p>
      <p className="text-xs text-gray-500 leading-relaxed">{description}</p>
    </div>
  );
};

export default WelcomeStep;
